const isFileAccepted = (file: File, acceptFormat:string = 'image/*') => {

    const acceptedTypes = acceptFormat.split(',').map(type => type.trim());

    return acceptedTypes.some(type => {
        if (type.endsWith('/*')) {
            return file.type.startsWith(type.slice(0, -2));
        }
        if (type.startsWith('.')) {
            return file.name.toLowerCase().endsWith(type.toLowerCase());
        }
        return file.type === type;
    });
}


export default isFileAccepted;